import type { AnnouncementBannerConfig } from '@/versions/v1/shared/admin-seed';

export const ANNOUNCEMENT_BANNER_MAX_LENGTH = 280;

export function publicBannerFromConfig(
  config: AnnouncementBannerConfig,
): { message: string; updatedAt: string } | null {
  if (!config.enabled) return null;
  const msg = config.message.trim();
  if (msg.length === 0) return null;
  return { message: msg, updatedAt: config.updatedAt };
}

export function nextAnnouncementBannerEnabled(
  config: AnnouncementBannerConfig,
): AnnouncementBannerConfig {
  return { ...config, enabled: !config.enabled };
}

export function saveAnnouncementBannerMessage(
  config: AnnouncementBannerConfig,
  message: string,
): AnnouncementBannerConfig {
  return { ...config, message: message.trim() };
}

export function validateAnnouncementBannerMessage(
  enabled: boolean,
  trimmed: string,
): string | null {
  if (enabled && trimmed.length === 0) {
    return 'A message is required when the banner is enabled';
  }
  if (trimmed.length > ANNOUNCEMENT_BANNER_MAX_LENGTH) {
    return `Message must be ${ANNOUNCEMENT_BANNER_MAX_LENGTH} characters or fewer`;
  }
  return null;
}

export function dismissalKey(updatedAt: string): string {
  return `banner:dismissed:${updatedAt}`;
}
